/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import { get } from 'embercom/lib/ajax';
import { action } from '@ember/object';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type RouterService from '@ember/routing/router-service';
export default class ContentGapsStandaloneRoute extends Route {
  @service declare appService: $TSFixMe;
  @service declare store: Store;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare router: RouterService;
  analytics = {
    section: 'standalone',
    place: 'content-gaps',
  };

  get titleToken() {
    return this.intl.t('standalone.content-gaps.title');
  }

  async beforeModel() {
    if (this.appService.app.canSeeAiInsightsBeta) {
      this.router.transitionTo('apps.app.standalone.optimize-fin');
      return;
    }
  }

  async model() {
    await Promise.all([this.aiAgentSetupService.load(), this.finStandaloneService.initialize()]);

    let latestQuestionExtractionRunId = await this.loadLastQuestionGroupsRunDetails();
    let finIsLive = this.finIsLive;
    return {
      latestQuestionExtractionRunId,
      finIsLive,
    };
  }

  async loadLastQuestionGroupsRunDetails(): Promise<$TSFixMe> {
    let response = await get(
      '/ember/ai_agent/question_groups/latest_question_extraction_run_details',
      {
        app_id: this.appService.app.id,
      },
    );
    return response.id;
  }

  @action
  refreshModel() {
    this.refresh();
  }

  get finIsLive(): boolean {
    return this.finStandaloneService.finIsLive;
  }
}
